import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Account } from '@app/types/account';
import { Invoice } from '@app/types/invoice';
import { RatePlan } from '@app/types/rate-plan';
import { Subscription } from '@app/types/subscription';
import { environment } from '@env/environment';

@Injectable()
export class PpApiGatewayService {
  private api = `${environment.ppApiGateway}/billing-history`;

  constructor(private http: HttpClient) {}

  getSubscriptionsByContactId(contactId) {
    const params = new HttpParams().set('purchaserContactId', contactId);

    return this.http.get<Array<Subscription>>(`${this.api}/subscriptions`, {
      params,
    });
  }

  getAccountsByContactId(contactId) {
    const params = new HttpParams().set('purchaserContactId', contactId);

    return this.http.get<Array<Account>>(`${this.api}/accounts`, {
      params,
    });
  }

  updateAutoRenewal(autoRenew: boolean, accountId: string) {
    const params = new HttpParams().set('autoRenew', autoRenew.toString());
    return this.http.put(`${environment.ppApiGateway}/accounts/${accountId}/subscriptions/auto-renewal`, null, {
      params
    });
  }

  getSubscriptionRatePlanBySubscriptionName(subscriptionName) {
    return this.http.get<Array<RatePlan>>(
      `${this.api}/subscriptions/${subscriptionName}/rate-plans`
    );
  }

  getInvoicesByContactId(contactId) {
    const params = new HttpParams().set('purchaserContactId', contactId);

    return this.http.get<Array<Invoice>>(`${this.api}/invoices`, { params });
  }

  getInvoicePdfByInvoiceId(invoiceId) {
    return this.http.get(`${this.api}/invoices/${invoiceId}/pdf`, {
      responseType: 'blob',
    });
  }

  requestCancellationCall(contactId) {
    return this.http.put(`${this.api}/contacts/${contactId}/cancel-call-campaign`, {});
  }
}
